export default "__VITE_ASSET__CUEg_iB___"